<div class="flex flex-col py-8 justify-center items-center" style="overflow: hidden;">
  <div class="container-padding max-w-screen-desktop mx-auto w-full">
    <div class="flex justify-center items-center">
      <div class="py-6 px-6 shadow rounded-2xl sm:px-10 my-4 border border-4 border-[var(--black)] bg-[var(--white)] w-full max-w-[600px]">
        <h2 class="uppercase text-[42px]/[65px] font-normal text-[var(--dark-orange)]">
          {{ 'resendVerification.title' | translate }}
        </h2>
        <div class="w-full border-t border-dotted mb-6 mt-2"></div>

        <form [formGroup]="verificateEmailForm" (submit)="onSubmit()" class="">
          <div class="flex flex-col gap-6">
            <app-input [control]="verificateEmailForm.controls['email']" inputId="email" autocomplete="email" type="email" placeholder="usuario@correo.com"
              [label]="'resendVerification.email' | translate"></app-input>
          </div>

          <div class="mt-8">
            <app-button [submit]="true" [disabled]="isLoading" [text]="isLoading ? ('resendVerification.loading' | translate) : ('resendVerification.submit' | translate)" [fullWidth]="true"></app-button>
          </div>

          <div *ngIf="errorMessage" class="mt-6 font-bold text-[14px]/[14px] text-center" style="color: red;">
            {{ errorMessage }}
          </div>

          <div *ngIf="successMessage" class="mt-6 font-bold text-[14px]/[14px] text-center" style="color: green;">
            {{ successMessage }}
          </div>

          <div class="mt-12 flex justify-center p-3">
            <a routerLink="/login" class="uppercase font-bold text-[var(--black)] text-[14px]/[14px]">
              {{ 'resendVerification.login' | translate }}
            </a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
